<template>
  <div class="legal-page">
    <div class="container">
      <header class="header">
        <router-link to="/" class="back-link">← Back to Home</router-link>
        <h1 class="page-title">Terms of Service</h1>
        <p class="last-updated">Last updated: {{ lastUpdated }}</p>
      </header>

      <div class="content">
        <section class="section">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using Hrafnabók, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
        </section>

        <section class="section">
          <h2>2. Description of Service</h2>
          <p>Hrafnabók is an Icelandic language learning application that provides interactive lessons, exercises, and educational content to help users learn the Icelandic language.</p>
        </section>

        <section class="section">
          <h2>3. User Accounts</h2>
          <p>To access certain features of the service, you may be required to create an account. You are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of your account information</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us immediately of any unauthorized use</li>
            <li>Providing accurate and complete information</li>
          </ul>
        </section>

        <section class="section">
          <h2>4. User Conduct</h2>
          <p>You agree not to use the service to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe upon the rights of others</li>
            <li>Submit false or misleading information</li>
            <li>Interfere with or disrupt the service</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Use the service for any commercial purpose without permission</li>
          </ul>
        </section>

        <section class="section">
          <h2>5. Intellectual Property</h2>
          <p>The service and its original content, features, and functionality are owned by Hrafnabók and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
        </section>

        <section class="section">
          <h2>6. User Content</h2>
          <p>You retain ownership of any content you submit to the service. By submitting content, you grant us a non-exclusive, royalty-free license to use, modify, and distribute your content in connection with the service.</p>
        </section>

        <section class="section">
          <h2>7. Privacy Policy</h2>
          <p>Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the service, to understand our practices.</p>
        </section>

        <section class="section">
          <h2>8. Subscription and Payment</h2>
          <p>Some features of the service may require a paid subscription. By subscribing, you agree to pay all fees associated with your subscription. Subscription fees are non-refundable except as required by law.</p>
        </section>

        <section class="section">
          <h2>9. Termination</h2>
          <p>We may terminate or suspend your account and access to the service immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use the service will cease immediately.</p>
        </section>

        <section class="section">
          <h2>10. Disclaimers</h2>
          <p>The service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the service will be uninterrupted, error-free, or secure.</p>
        </section>

        <section class="section">
          <h2>11. Limitation of Liability</h2>
          <p>In no event shall Hrafnabók be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, or other intangible losses.</p>
        </section>

        <section class="section">
          <h2>12. Governing Law</h2>
          <p>These Terms shall be governed and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.</p>
        </section>

        <section class="section">
          <h2>13. Changes to Terms</h2>
          <p>We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.</p>
        </section>

        <section class="section">
          <h2>14. Contact Information</h2>
          <p>If you have any questions about these Terms, please contact us at:</p>
          <p class="contact-info">
            Email: legal@hrafnabok.com
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfServicePage',
  data() {
    return {
      lastUpdated: new Date().toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: white;
  padding: 2rem 1rem;
}

.container {
  max-width: 48rem;
  margin: 0 auto;
}

.header {
  margin-bottom: 3rem;
  text-align: center;
}

.back-link {
  display: inline-block;
  margin-bottom: 1rem;
  color: hsl(173, 58%, 39%);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.back-link:hover {
  color: hsl(173, 58%, 35%);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: black;
  margin-bottom: 0.5rem;
}

.last-updated {
  color: #6b7280;
  font-size: 0.875rem;
}

.content {
  line-height: 1.6;
}

.section {
  margin-bottom: 2rem;
}

.section h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: black;
  margin-bottom: 1rem;
}

.section h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: black;
  margin: 1.5rem 0 0.75rem 0;
}

.section p {
  margin-bottom: 1rem;
  color: #374151;
}

.section ul {
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.section li {
  margin-bottom: 0.5rem;
  color: #374151;
}

.contact-info {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
}

@media (min-width: 768px) {
  .legal-page {
    padding: 3rem 2rem;
  }
  
  .page-title {
    font-size: 3rem;
  }
}
</style>